import { Form } from "antd";
import { useTranslation } from "react-i18next";
import Upload from "components/upload";
import Input from "components/inputs";
import PaymentButton from "./button";
import Amount from "./amount";
import Accounts from "./accounts";

const ReceiptForm = ({
  bankAccounts,
  data,
  formRef,
  loading,
  trxUuid,
  onFinish,
}) => {
  const { t } = useTranslation();

  return (
    <Form
      name="receipt-payment"
      onFinish={onFinish}
      autoComplete="off"
      ref={formRef}
    >
      <div className="mx-5 py-10 px-5 rounded-lg  bg-white shadow-xl sm:shadow-none ">
        <Amount data={data} />

        <div className=" pt-10 space-y-5">
          <Accounts bankAccounts={bankAccounts} />
          <Upload
            required
            url={`pma/api/v1/upload/receipt/${trxUuid}`}
            accept=".png,.jpg,.jpeg,.pdf"
            isMaximSize={true}
          />
        </div>
      </div>
      <PaymentButton loading={loading} />
    </Form>
  );
};
export default ReceiptForm;
